var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "detalhamento-alocacao-estrategica",
      class: {
        "az-card-bordered": !_vm.contentOnly,
        "detalhamento-alocacao-estrategica--loading": _vm.loading,
        "detalhamento-alocacao-estrategica--content-only": _vm.contentOnly
      }
    },
    [
      _c(
        "FeedbackWrapper",
        {
          class: { "rounded-sm": !_vm.contentOnly },
          attrs: {
            loading: _vm.contentOnly ? false : _vm.loading,
            noData: _vm.hasNoData,
            message: _vm.noDataMessage,
            minHeight: _vm.contentOnly ? 0 : 425
          }
        },
        [
          _c(
            "div",
            { staticClass: "detalhamento-alocacao-estrategica__header" },
            [
              !_vm.contentOnly
                ? _c(
                    "div",
                    {
                      staticClass:
                        "detalhamento-alocacao-estrategica__title az-ds-card-title"
                    },
                    [_vm._v(" Detalhamento Alocação Estratégica ")]
                  )
                : _vm._e(),
              _c("BaseToggleButton", {
                staticClass: "detalhamento-alocacao-estrategica__toggle",
                attrs: {
                  value: _vm.viewMode || "estrategica",
                  options: _vm.viewModeOptions
                },
                on: { input: _vm.onChangeViewMode }
              }),
              _c(
                "div",
                {
                  staticClass:
                    "detalhamento-alocacao-estrategica__info az-text-primary az-size-12 font-semibold az-muted"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "detalhamento-alocacao-estrategica__info-perfil"
                    },
                    [
                      _c("span", [_vm._v(" Perfil cliente: ")]),
                      _c(
                        "span",
                        {
                          class: {
                            "text-danger":
                              !_vm.$currentUser().IS_CLIENTE &&
                              _vm.alocacaoClienteInvalida
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.perfil || "-") + " ")]
                      ),
                      !_vm.$currentUser().IS_CLIENTE &&
                      _vm.alocacaoClienteInvalida
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "icon-svg",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  name: "mdi-information",
                                                  size: "16",
                                                  color: "red"
                                                }
                                              },
                                              "icon-svg",
                                              attrs,
                                              false
                                            ),
                                            on
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3834097745
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " Para acompanhar a aderência, o perfil precisa estar detalhado por subclasse. "
                                ),
                                _c("br"),
                                _vm._v(" Ajuste em Configurações -> Perfis. ")
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.fractions && _vm.$isWhitelabel()
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "detalhamento-alocacao-estrategica__info-status"
                        },
                        [
                          _c("span", [_vm._v(" Status: ")]),
                          _c(
                            "span",
                            {
                              class: {
                                "text-success":
                                  _vm.statusBalanceamento === "Balanceado",
                                "text-danger": _vm.isDesbalanceado
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.statusBalanceamento) + " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.statusDesenquadramento
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "detalhamento-alocacao-estrategica__info-risco"
                        },
                        [
                          _c("span", [_vm._v(" Risco ANBIMA: ")]),
                          _c(
                            "span",
                            {
                              class: {
                                "text-success": _vm.isRiscoDentro,
                                "text-danger": _vm.isRiscoAcima
                              },
                              style: _vm.statusRiscoAnbimaStyle
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.statusDesenquadramento) + " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.temFundoComposto && _vm.showStatisticsGroup
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "detalhamento-alocacao-estrategica__info-expandir"
                        },
                        [
                          _c(
                            "BaseButton",
                            {
                              attrs: {
                                secondary: "",
                                text: "",
                                sm: "",
                                "fit-content": ""
                              },
                              on: { click: _vm.toggleFundoCompostoExpandido }
                            },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: _vm.fundoCompostoExpandidoLocal
                                    ? "mdi-checkbox-marked"
                                    : "mdi-checkbox-blank-outline",
                                  size: 16,
                                  color: "primary"
                                }
                              }),
                              _vm._v(" Expandir ativos com composição ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _vm.isDesenquadramentoView
            ? _c(
                "div",
                { staticClass: "d-flex flex-column justify-content-between" },
                [
                  _c(
                    "FeedbackWrapper",
                    {
                      attrs: {
                        noData: _vm.mostraEstadoVazioDesenquadramento,
                        minHeight: 160
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "content",
                            fn: function() {
                              return [
                                _vm.mostraConviteAnbima
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        attrs: {
                                          "data-testid":
                                            "convite-configurar-anbima"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 az-text-primary az-size-14 font-semibold"
                                          },
                                          [
                                            _vm._v(
                                              " Este perfil ainda não tem máximos ANBIMA definidos "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 mt-1 az-text-primary az-size-12 az-muted"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.conviteAnbimaTexto()
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _vm.podeConfigurarAnbima()
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-center mt-4"
                                              },
                                              [
                                                _c(
                                                  "BaseButton",
                                                  {
                                                    attrs: {
                                                      "data-testid":
                                                        "cta-configurar-anbima",
                                                      primary: "",
                                                      "fit-content": "",
                                                      "min-width": "auto"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.irParaConfiguracaoMaximosAnbima
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Definir máximos ANBIMA "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm.mostraEstadoSemPerfil
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        attrs: {
                                          "data-testid": "estado-sem-perfil"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 az-text-primary az-size-14 font-semibold"
                                          },
                                          [
                                            _vm._v(
                                              " Este cliente ainda não tem perfil de investidor "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 mt-1 az-text-primary az-size-12 az-muted"
                                          },
                                          [
                                            _vm._v(
                                              " Sem o perfil do investidor não há limites por classe ANBIMA para comparar com a carteira. "
                                            )
                                          ]
                                        ),
                                        _vm.mostraCtaDefinirPerfil
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-center mt-4"
                                              },
                                              [
                                                _c(
                                                  "BaseButton",
                                                  {
                                                    attrs: {
                                                      "data-testid":
                                                        "cta-definir-perfil",
                                                      primary: "",
                                                      "fit-content": "",
                                                      "min-width": "auto"
                                                    },
                                                    on: {
                                                      click: _vm.onDefinirPerfil
                                                    }
                                                  },
                                                  [_vm._v(" Definir perfil ")]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        attrs: {
                                          "data-testid": "estado-sem-posicao"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 az-text-primary az-size-14 font-semibold"
                                          },
                                          [
                                            _vm._v(
                                              " Sem posição para comparar "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 mt-1 az-text-primary az-size-12 az-muted"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.semPosicaoTexto()) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1891134598
                      )
                    },
                    [
                      _c("v-data-table", {
                        staticClass:
                          "detalhamento-alocacao-estrategica__table table-new-ux-v1",
                        attrs: {
                          id: "tabela-alocacao-anbima",
                          headers: _vm.anbimHeaders,
                          items: _vm.desenquadramentoTableItems,
                          "header-props": { "sort-icon": "mdi-chevron-up" },
                          "sort-by": ["fracao"],
                          "sort-desc": [true],
                          dense: "",
                          "hide-default-footer": "",
                          "disable-pagination": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item.color",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("div", {
                                    style: { "background-color": item.barColor }
                                  })
                                ]
                              }
                            },
                            {
                              key: "item.classe_anbima",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(item.classe_anbima))
                                  ]),
                                  item.isOutrosGroup
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { right: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass: "ml-1",
                                                            attrs: {
                                                              icon: "",
                                                              "x-small": "",
                                                              "aria-label":
                                                                "Ver classes somadas no teto de Outros"
                                                            }
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c("icon-svg", {
                                                          attrs: {
                                                            name: "plus",
                                                            size: 16,
                                                            color: "#8E8E8E"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "caption font-semibold mb-1"
                                                },
                                                [
                                                  _vm._v(
                                                    " Somadas contra o teto de 'Outros': "
                                                  )
                                                ]
                                              ),
                                              _vm._l(
                                                item.outrosBreakdown,
                                                function(breakdown) {
                                                  return _c(
                                                    "div",
                                                    { key: breakdown.classe },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            breakdown.classe
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            _vm.formatPctMaybeNull(
                                                              breakdown.fracao
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "item.fracao",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatPctMaybeNull(item.fracao)
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.maxPct",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatPctMaybeNull(item.maxPct)
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.diff",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  item.isOverLimit && item.diff !== null
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { right: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                icon: ""
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("icon-svg", {
                                                              attrs: {
                                                                name:
                                                                  "mdi-menu-up-outline",
                                                                size: "20",
                                                                color: "red"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatPctMaybeNull(
                                                      item.diff
                                                    )
                                                  ) + " acima do máximo"
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : item.isNear
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { right: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                icon: ""
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("icon-svg", {
                                                              attrs: {
                                                                name:
                                                                  "mdi-alert-outline",
                                                                size: "20",
                                                                color: "warning"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Próximo ao limite — dentro de 10% relativo do máximo"
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("span", [_vm._v("—")])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2455310181
                        )
                      })
                    ],
                    1
                  ),
                  _vm.mostraStatusGeral
                    ? _c(
                        "small",
                        {
                          staticClass:
                            "mt-3 az-text-primary az-size-12 font-semibold",
                          class: {
                            "text-danger": _vm.isRiscoAcima,
                            "text-success": _vm.isRiscoDentro
                          },
                          style: _vm.statusRiscoAnbimaStyle
                        },
                        [
                          _vm._v(
                            " Status geral: " +
                              _vm._s(_vm.statusDesenquadramento) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "d-flex flex-column justify-content-between" },
                [
                  _c(
                    "FeedbackWrapper",
                    {
                      attrs: {
                        noData: _vm.mostraEstadoVazioEstrategica,
                        minHeight: 160
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "content",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "text-center",
                                  attrs: {
                                    "data-testid": "estado-vazio-estrategica"
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "ma-0 az-text-primary az-size-14 font-semibold"
                                    },
                                    [_vm._v(" Sem posição para exibir ")]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "ma-0 mt-1 az-text-primary az-size-12 az-muted"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.estrategicaVaziaTexto) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c("v-data-table", {
                        staticClass:
                          "detalhamento-alocacao-estrategica__table table-new-ux-v1",
                        attrs: {
                          id: "tabela-alocacao-estrategica",
                          headers: _vm.tableHeaders,
                          items: _vm.tableItems,
                          "custom-sort": _vm.customSort,
                          "header-props": {
                            "sort-icon": "mdi-chevron-up"
                          },
                          "sort-by": _vm.sortByValue,
                          "sort-desc": [true],
                          dense: "",
                          "hide-default-footer": "",
                          "disable-pagination": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item.color",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("div", {
                                    style: { "background-color": item.color }
                                  })
                                ]
                              }
                            },
                            {
                              key: "item.name",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("div", [
                                    _vm._v(" " + _vm._s(item.name) + " "),
                                    item.hasComposition
                                      ? _c("span", [_vm._v("*")])
                                      : _vm._e()
                                  ])
                                ]
                              }
                            },
                            {
                              key: "item.composicao_perfil",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.composicao_perfil &&
                                            _vm.showStatisticsGroup
                                            ? _vm.decToPercent(
                                                item.composicao_perfil,
                                                1
                                              )
                                            : "-"
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "item.diff",
                              fn: function(ref) {
                                var _obj

                                var item = ref.item
                                return [
                                  _vm.fractions &&
                                  _vm.showStatisticsGroup &&
                                  _vm.perfil &&
                                  item.diff
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              class:
                                                ((_obj = {}),
                                                (_obj[
                                                  "icone-aviso-" + item.signal
                                                ] = true),
                                                (_obj["icone-aviso-red"] =
                                                  _vm.isDesbalanceado),
                                                _obj),
                                              attrs: { right: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                icon: ""
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("icon-svg", {
                                                              attrs: {
                                                                name: _vm.getDiffIcon(
                                                                  item.signal
                                                                ),
                                                                size: "20",
                                                                color:
                                                                  item.signalClass
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.decToPercent(
                                                        item.diff
                                                      )
                                                    ) +
                                                    " fora do sugerido "
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "item.rentabilidade",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  typeof item.rentabilidade === "number"
                                    ? _c("GeneralValueDiff", {
                                        staticStyle: {
                                          margin: "0 !important",
                                          "font-size": "12px"
                                        },
                                        attrs: {
                                          value: item.rentabilidade,
                                          "value-formatted": _vm.decToPercent(
                                            item.rentabilidade
                                          )
                                        }
                                      })
                                    : _c("span", [_vm._v(" - ")])
                                ]
                              }
                            },
                            {
                              key: "item.vol",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.vol && _vm.showStatisticsGroup
                                          ? _vm.decToPercent(item.vol)
                                          : "-"
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            _vm.fundoCompostoExpandido && _vm.temFundoComposto
                              ? {
                                  key: "body.append",
                                  fn: function() {
                                    return [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              colspan: _vm.tableHeaders.length
                                            }
                                          },
                                          [
                                            _c(
                                              "small",
                                              { staticClass: "az-text-small" },
                                              [
                                                _vm._v(
                                                  " * Parte da alocação da classe é da composição de um ativo. "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              : null
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  !_vm.showStatisticsGroup
                    ? _c("small", { staticClass: "az-text-small mt-3" }, [
                        _vm._v(
                          " * Este agrupamento não permite visualização da rentabilidade e vol. específicos. "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }